import { Component, OnInit } from '@angular/core';
import { MessageService } from 'src/app/services/message.service';
import { NavigationNodeRuleService } from 'src/app/services/navigation/navigation-node-rule.service';
import { SubmenuService } from '../../submenu/submenu.service';
import { UserSearchSettingService } from 'src/app/services/search/user-search-setting.service';

@Component({
  selector: 'app-user-search-setting-list',
  templateUrl: './user-search-setting-list.component.html',
  styleUrls: ['./user-search-setting-list.component.less']
})
export class UserSearchSettingListComponent implements OnInit {

  page:number = 1;
  pageSize:number = 25;
  queryString= "";
  listData:any[];

  constructor(public userSearchSettingService:UserSearchSettingService, public messageService:MessageService, public submenuService:SubmenuService)
  { 

  }

  ngOnInit(): void {
    
    this.loadData();
  }

  ngAfterViewChecked(){
    this.submenuService.showRecordList("/usersearchsetting");    
  }

  loadData(){
    this.messageService.showLoading();
    this.userSearchSettingService.loadPage(this.page, this.pageSize, this.queryString).subscribe((data:any) => {
        this.listData = data;
        this.messageService.hideLoading();
    },
    
    err => {
      this.messageService.hideLoading();
      this.messageService.showMessage(err.message, "error");
      console.log(err);
    });
  }

}